import { render, staticRenderFns } from "./organizationOrder.vue?vue&type=template&id=a685a786&scoped=true"
import script from "./organizationOrder.vue?vue&type=script&lang=js"
export * from "./organizationOrder.vue?vue&type=script&lang=js"
import style0 from "./organizationOrder.vue?vue&type=style&index=0&id=a685a786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a685a786",
  null
  
)

export default component.exports